<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12">
        <v-toolbar-title>Dashboard</v-toolbar-title>
      </v-col>
    </v-row>
    <DealerSummaryReport></DealerSummaryReport>
    <!-- <DailyRevenue></DailyRevenue> -->
    <DailyActivation></DailyActivation>
    <!-- <DailySignUp></DailySignUp> -->
  </v-container>
</template>

<script>
import DealerSummaryReport from "./components/DealerSummaryReport.vue";
// import DailyRevenue from "../page_components/dashboard_components/DailyRevenue.vue";
import DailyActivation from "../acquisition/components/dashboard_components/DailyActivation.vue";
// import DailySignUp from "../page_components/dashboard_components/DailySignUp.vue";

export default {
  name: "Dashboard",
  components: {
    DealerSummaryReport,
    // DailyRevenue,
    DailyActivation,
    // DailySignUp
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
